import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import ScrollToTop from 'react-scroll-to-top';
import App from './App';
import history from './history';
import { unregister } from './registerServiceWorker';
import { configureStore } from './store';
import fetchConfig from './config/fetch';
import './fontAwesome';
import './styles/app.css';
import { ThemeProvider } from 'styled-components';
import { mantineTheme } from './theme';
import { MantineProvider } from '@mantine/core';
import { msalInstance } from './config/azureAd';
import { ENVIRONMENTS } from './helpers';
import { MsalProvider } from '@azure/msal-react';
import Clarity from '@microsoft/clarity';
import {
  EventType,
} from '@azure/msal-browser';

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

// Configure fetch
fetchConfig.setupInterceptors(store);

// Whenever the route changes
// Put things here that you want to happen on page change, like analytics for example
history.listen(() => {
  // Reset scroll position to top of screen
  window.scrollTo(0, 0);
});

// Account selection logic is app dependent. Adjust as needed for different use cases.
// Set active acccount on page load
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event) => {
  // set active account after redirect
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
}, error => {
  console.log('error', error);
});

// Initialize MS Clarity. This is not a secret, and is a static value
if (process.env.NODE_ENV === ENVIRONMENTS.PRODUCTION) {
  Clarity.init('q4medzw3ch')
}

// handle auth redired/do all initial setup for msal
msalInstance.handleRedirectPromise().then((authResult) => {
  // Check if user signed in
  const account = msalInstance.getActiveAccount();
  if (!account) {
    // redirect anonymous user to login page
    msalInstance.loginRedirect();
  }
});

//TODO: we should fix this
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ThemeProvider theme={{}}>
          <MantineProvider theme={mantineTheme} withGlobalStyles withNormalizeCSS>
            <App />
          </MantineProvider>
        </ThemeProvider>
      </ConnectedRouter>
      <ReduxToastr
        timeOut={2000}
        transitionIn="bounceInDown"
        transitionOut="bounceOutUp"
        position="top-center"
        preventDuplicates
        closeOnToastrClick
      />
      <ScrollToTop smooth/>
    </Provider>
  </MsalProvider>,
  document.getElementById('root'),
);

unregister();
